export default "__VITE_PUBLIC_ASSET__fd1a0537__"